import { ReactComponent as SuccessIcon } from 'assets/icons/fonbet/success-icon.svg';
import { useAmount, useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { transformDateMoment } from 'utils';

import { BaseCard, Button } from '../ui';

const CheckSuccess = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { formattedFullAmount } = useAmount();
  const { t } = useTranslate();

  return (
    <BaseCard>
      <div className="flex flex-col gap-6">
        <div className="flex justify-center items-center gap-3">
          <SuccessIcon className="w-6 md:w-8 h-6 md:h-8" />
          <span className="text-lg md:text-2xl leading-5 md:leading-[30px] font-semibold text-fonbet-black">
            {t('fonbet.payment-success')}
          </span>
        </div>
        <div className="text-base md:text-lg leading-5 md:leading-[30px] flex flex-col gap-5 md:gap-6">
          <dl className="flex flex-1">
            <dt className="text-fonbet-gray-200 w-full">{t('fonbet.info.transaction-number')}</dt>
            <dd className="text-fonbet-black w-full font-medium text-right md:text-xl">
              №{paymentData?.ID}
            </dd>
          </dl>
          <dl className="flex flex-1">
            <dt className="text-fonbet-gray-200 w-full">{t('fonbet.info.payment-date')}</dt>
            <dd className="text-fonbet-black w-full font-medium text-right md:text-xl ">
              {paymentData?.date && transformDateMoment(paymentData?.date)}
            </dd>
          </dl>
          <dl className="flex flex-1">
            <dt className="text-fonbet-gray-200 w-full">{t('fonbet.info.payment-amount')}</dt>
            <dd className="text-fonbet-black w-full font-medium text-right md:text-xl">
              {formattedFullAmount}
            </dd>
          </dl>
        </div>
        {paymentData?.returnURL && (
          <div>
            <Button href={paymentData?.returnURL}>{t('fonbet.home-page')}</Button>
          </div>
        )}
      </div>
    </BaseCard>
  );
};

export { CheckSuccess };
